// Deterministic string hash (djb2 variant) - used to derive stable per-item
// jitter/placement from a name so layout doesn't reshuffle across re-renders.
export function strHash(s) {
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = (Math.imul(h, 33) ^ s.charCodeAt(i)) >>> 0;
  return h;
}
